/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBdp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2.734 15.27V8h2.55c.927 0 1.607.157 2.04.47.44.313.66.8.66 1.46 0 .327-.086.62-.26.88-.173.26-.413.467-.72.62.86.267 1.29.837 1.29 1.71 0 1.42-.983 2.13-2.95 2.13zm1.5-4.26h.76c.527 0 .897-.067 1.11-.2.22-.14.33-.373.33-.7 0-.34-.106-.577-.32-.71-.213-.14-.586-.21-1.12-.21h-.76zm0 3.06h.99c.514 0 .89-.08 1.13-.24s.36-.41.36-.75c0-.333-.12-.577-.36-.73s-.616-.23-1.13-.23h-.99zm5.034 1.2V8h2.44c1.186 0 2.083.307 2.69.92.606.613.91 1.52.91 2.72 0 1.187-.304 2.09-.91 2.71-.6.613-1.497.92-2.69.92zm2.42-6h-.86V14h.86c.673 0 1.173-.19 1.5-.57.333-.387.5-.983.5-1.79s-.164-1.403-.49-1.79c-.327-.387-.83-.58-1.51-.58zm4.728 6V8h2.6c.893 0 1.567.207 2.02.62.46.413.69 1.027.69 1.84 0 .807-.23 1.42-.69 1.84-.453.413-1.127.62-2.02.62h-1.05v2.35zm2.28-6h-.73v2.38h.73c.533 0 .91-.09 1.13-.27.227-.187.34-.493.34-.92 0-.433-.113-.74-.34-.92-.22-.18-.597-.27-1.13-.27z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBdp as Bdp };
